import { useModal } from '@hooks/useModal';
import { ReactElement, useEffect } from 'react';
import styled from 'styled-components';
import CustomAlert from '../../../../components/CustomAlert';
import { ComponentName, GeolocationServices } from '../../../../constants';
import { useI18n } from '../../../../hooks/useI18n';
import { useGeoComplyMk2 } from '../../../geo-comply-provider.tsx';

const StyledErrorMessage = styled.span`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  max-width: 90%;
`;

const StyleReadMoreText = styled.span`
  cursor: pointer;
  text-decoration: underline;
  white-space: nowrap;
  display: block;
  overflow: hidden;
  max-width: 100%;
  margin-left: 10px;
`;

const ReadMoreButton = () => {
  const { t } = useI18n();
  const { enableModal } = useModal();
  const { setShowModal } = useGeoComplyMk2();
  return (
    <StyleReadMoreText
      className="styled-read-more-text"
      onClick={() => {
        enableModal(ComponentName.GeoComplyModal);
        setShowModal(true);
      }}
    >
      {t('geo_comply_read_more')}
    </StyleReadMoreText>
  );
};

const GeocomplyAlert = () => {
  const { t } = useI18n();
  const { errorMessages, errorCode, setShowModal, validating, inProgress } =
    useGeoComplyMk2();
  const { activeModal } = useModal();
  const isGeoComplyEnabled =
    window.__config__.componentSettings?.geolocationSettings?.service ===
    GeolocationServices.GeoComply;
  if (!isGeoComplyEnabled) {
    return null;
  }
  if (activeModal === ComponentName.ValidateGeoModal) return <></>;
  return (
    <>
      {(inProgress || !!errorCode) && (
        <CustomAlert
          show={true}
          variant={inProgress ? 'warning' : 'danger'}
          className="rounded-0"
        >
          <span className="d-flex">
            <StyledErrorMessage>
              {inProgress ? t('geo_validation_in_progress') : errorMessages[0]}
            </StyledErrorMessage>
            <ReadMoreButton />
          </span>
        </CustomAlert>
      )}
    </>
  );
};
export default GeocomplyAlert;
